import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../Button';
import { LocalizationContext } from '../../../../hoc/Localization';
import { sortingKeys } from '../../../../utils/directory';
import styles from '../styles.less';

const SortingFilter = ({ sort, pushFilters }) => {
  const { t } = React.useContext(LocalizationContext);

  return (
    <>
      {sortingKeys.map(key => (
        <Button
          type="secondary"
          className={key === sort ? styles.active : null}
          key={key}
          onClick={() => {
            pushFilters({
              sort: key,
            });
          }}
        >
          {t(`search.sort.${key}`)}
        </Button>
      ))}
    </>
  );
};

SortingFilter.propTypes = {
  sort: PropTypes.string,
  pushFilters: PropTypes.func,
};

SortingFilter.defaultProps = {
  sort: sortingKeys[0],
  pushFilters: () => null,
};

export default SortingFilter;
